export const tiktok = {
  tokenHelp:
    'Der Token ist zu finden unter "Apps and sales channels > Develop Apps"',
  oAuthFlowHelp: "Meinen Shop verbinden",
  authSuccess: "Authentifizierung erfolgreich",
  migrationSuccess: "Erolgreich Token aus Shopify übernommen.",
  helpText:
    "Mit TikTok Shop authentifizieren – Sie werden zu TikTok weitergeleitet und nach erfolgreicher Anmeldung zurück zu Xentral geführt."
};
